import { useCallback, useState } from 'react';
import { useCreditCardContext } from './credit-card-context-provider';
import { creditCardFieldLabels, creditCardPlaceholders } from './message';

const useCreditCardField = (fieldName) => {
  const { creditCardInfo, onChange, onBlur, errors } = useCreditCardContext();

  const [touched, setTouched] = useState(false);

  const _onChange = useCallback(
    (value) => {
      onChange(fieldName, value);
    },
    [onChange, fieldName],
  );

  const _onBlur = useCallback(
    (value) => {
      setTouched(true);
      onBlur(fieldName, value);
    },
    [onBlur, fieldName, setTouched],
  );

  return {
    value: creditCardInfo[fieldName],
    error: errors?.[fieldName],
    labelDescriptor: creditCardFieldLabels[fieldName],
    placeholderDescriptor: creditCardPlaceholders[fieldName],
    onChange: _onChange,
    onBlur: _onBlur,
    touched,
  };
};

export default useCreditCardField;
